import { Link } from 'react-router-dom';
import { featuredRecommendations } from '@/mocks/movies';

export default function FeaturedRecommend() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500">
            编辑精挑细选，品质保证
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featuredRecommendations.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ aspectRatio: '2/3' }}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-xs text-background-50 line-clamp-3 leading-relaxed">
                    {movie.description}
                  </p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 mb-1">
                {movie.title}
              </h3>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400"></i>
                  {movie.rating}
                </span>
                <span className="whitespace-nowrap">{movie.category} · {movie.year}</span>
              </div>
              <div className="mt-2 flex flex-wrap gap-1">
                {movie.tags.slice(0, 3).map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 bg-secondary-100 text-secondary-600 text-xs rounded-md whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}